module.exports = {
  about: {
    title: 'About Webjomp',
    desc: {
      1: 'Founder of Webjomp, François-Xavier Lemire a B.Sc. in Computer Science with a major in software engineering from ' +
      'McGill University in 2016. He also holds an LL.B. from the Université de Montréal since 2010 and is registered to the ' +
      'Québec Bar Roll of Order since 2011, being a former lawyer at {lla}',
      2: 'François-Xavier has applied his unique engineering skills in many domains including {fintech} at {morgan}, mobile ' +
      'in-app advertising at {vungle}, San Francisco and gaming at {beenox} where he worked on the blockbuster success {skylanders}.',
      3: 'If you don’t find him brainstorming for the next big thing, he’s most probably playing trumpet, tasting scotch or boxing!',
      4: 'Make sure to stay in touch!',
    },
  },
  banner: {
    header: {
      default: 'The web, ',
      span: 'reimagined',
    },
    desc: 'Website design, mobile app development and consulting.',
    cta: 'Learn More',
  },
  contact: {
    title: 'Contact Us',
    form: {
      name: 'Name',
      email: 'E-mail',
      topic: 'Topic',
      message: 'Message',
      receiveCopy: 'Receive a copy',
      send: 'Send',
      confirm: {
        success: 'ReCaptcha solved? We\'ll get back to you very soon!',
        error: 'ERROR: There was an error sending the form. Please try again later.',
        popup: 'ERROR: Please allow popups, then retry and complete a reCaptcha.',
        close: 'Close',
      },
    },
    email: 'E-mail',
    phone: 'Phone',
    where: 'Where',
  },
  menu: {
    home: 'Home',
    contact: 'Contact',
    about: {
      title: 'About Us',
      page: 'about',
    },
    services: {
      title: 'Our Services',
      page: 'services',
    },
  },
  landing: {
    tiles: {
      moderne: {
        title: 'Modern websites',
        desc: 'Attract your clients with a fresh look.',
      },
      agile: {
        title: 'Agile',
        desc: 'Be involved throughout your website\'s creation and get the result you want.',
      },
      beton: {
        title: 'Rock Solid',
        desc: 'We use cutting-edge technologies to ensure your website stays fast, bug-free and up to date.',
      },
      adaptatif: {
        title: 'Responsive',
        desc: 'Enjoy good UI and UX, whether on mobile or PC.',
      },
      clair: {
        title: 'Which You\'ll Understand',
        desc: 'We make sure all your questions are answered.',
      },
      abordable: {
        title: 'At reasonable prices',
        desc: 'We minimize accessory fees such as hosting and domain acquisition.',
      },
    },
    services: {
      title: 'Our Services',
      websites: 'Websites',
      apps: 'Apps',
      consulting: 'Consulting',
      cta: 'Learn More',
    },
    clients: { title: 'Some of our clients' },
  },
  services: {
    title: 'Webjomp - Services',
    header: 'Our Services',
    desc: 'Website design, mobile app development and consulting.',
    main: {
      header: 'Way more than websites',
      desc: 'On top of website design, Webjomp offers a wide variety of services such as custom mobile app (Android, iOS and Windows) ' +
        'and software development tailored to the needs of your industry.',
      cta: 'Learn more',
    },
    websites: {
      header: 'Websites',
      list: {
        1: 'eCommerce',
        2: 'Responsive',
        3: 'Blogs',
        4: 'Search Engine Optimization (SEO)',
        5: 'Email Marketing',
        6: 'Writing and Translation',
        7: 'Original Designs and Makeovers',
        8: 'Static and Dynamic Pages',
        9: 'Maps and Calendars',
        10: 'Social Networks',
        11: 'Chat Platform',
        12: 'Contact Forms',
        13: 'Data Analytics',
        14: 'Advertisement',
        15: 'Custom Domain Acquisition',
        16: 'Web Hosting',
      },
      more: {
        content: 'Can\'t find what you need? Don\'t hesitate to {anchor}!',
        anchor: 'contact us',
      },
    },
    apps: {
      header: 'Mobile Apps',
      desc: {
        p1: 'We develop for Android, iOS and Windows Phones.',
        p2: 'You have an idea in mind? We bring it to life with you through the following steps: ' +
          'identify the requirements, create a design, develop and test the features, publish the app to the store.',
        p3: 'But that\'s not all! We stay with you and keep your app up to date to ensure its performance, and we ' +
          'improve its design and features by analyzing your users\' data and behavior.',
      },
    },
    consulting: {
      header: 'Consulting',
      desc: 'Focus on what you\'re pro at.',
      software: {
        header: 'Custom Software Development',
        desc: 'Data visualization, task automation.',
      },
      solutions: {
        header: 'Business Solutions',
        desc: 'Billing, office, accounting, salaries, project management, customer management system (CMS).',
      },
      pm: {
        header: 'Project Management',
        desc: 'Client presentations, schedule management, quality assurance (QA).',
      },
      strategy: {
        header: 'Business Strategy',
        desc: 'Advertisement, search engine optimization (SEO), data analytics, new software solutions, growth and scaling advising.',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/data/messages/en.js